(function () {
  angular.module("akitabox.desktop.asset", [
    "ui.router",
    "akitabox.constants",
    "akitabox.core.constants",
    "akitabox.core.router",
    "akitabox.core.services.asset",
    "akitabox.core.services.floor",
    "akitabox.core.services.filter",
    "akitabox.core.services.room",
    "akitabox.core.services.pin",
    "akitabox.core.services.pinType",
    "akitabox.core.toast",
    "akitabox.desktop.asset.detail",
    "akitabox.desktop.asset.list",
    "akitabox.desktop.asset.organizationList",
    "akitabox.ui.dialogs.asset.create",
    "akitabox.ui.dialogs.export",
  ]);
})();
